"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1448],{

/***/ 11448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MobileHeroSection_MobileHeroSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(39664);
var ScrollToPlugin_default = /*#__PURE__*/__webpack_require__.n(ScrollToPlugin);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/icons/Logos/BlackLongLogo.tsx
var BlackLongLogo = __webpack_require__(17626);
// EXTERNAL MODULE: ./node_modules/typewriter-effect/dist/react.js
var dist_react = __webpack_require__(5459);
var dist_react_default = /*#__PURE__*/__webpack_require__.n(dist_react);
;// CONCATENATED MODULE: ./src/views/Home/MobileHeroSection/MobileHeroSection.tsx







gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollToPlugin_default()));
function MobileHeroSection() {
    var ref = (0,react.useState)(), scrollHeight = ref[0], setScrollHeight = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        setScrollHeight((ref = document.getElementById("HeroSection")) === null || ref === void 0 ? void 0 : ref.scrollHeight);
    }, [
        scrollHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:hidden md:ml-5 h-[100svh]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "px-10 flex items-center h-full relative w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "-mt-32 landscape:-mt-10 md:space-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-5 -translate-x-8 opacity-0 _heroWhoWEAreName md:pb-0 pb-3 landscape:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-[1.5rem] inline-block h-[2px] bg-primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "similiar-text-style text-[#333333] tracking-[0.09em] uppercase",
                                        children: "WELCOME"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "_heroLogo -translate-y-8 opacity-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackLongLogo/* default */.Z, {
                                    classes: "w-[240px] h-[100px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " md:leading-[44px] md:text-[36px] text-[22px] leading-[1.22727em] md:tracking-normal tracking-[-.06714rem] text-[#4A4A4A] w-full _heroDescText opacity-0 translate-y-8 font-light md:pt-0 pt-[24px] slider:w-[70%]",
                                children: "Creating digital experiences where thinking is made visual."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 left-0 px-8 pb-6 flex justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[80%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "border-[#BEBEBE] _heroDownHr"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-3 space-x-4 whitespace-pre flex flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "lg:text-[#808080] text-redblack leading-[20px] text-[14px] text-sm inline-block -translate-x-8 opacity-0 _heroGrid1Text1",
                                                children: "Now proudly working with"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold text-redblack text-[13px] tracking-[.14em] leading-4 inline-block translate-x-8 opacity-0 _heroGrid1Text2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "-translate-x-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_react_default()), {
                                                        options: {
                                                            strings: [
                                                                "Urban One",
                                                                "Verizon",
                                                                "Ondemand Advisors",
                                                                "The North Face ",
                                                                "iDreamers",
                                                                "Harlem Capital",
                                                                "Blakademik",
                                                                "NAACP",
                                                                "OpenPhone", 
                                                            ],
                                                            autoStart: true,
                                                            deleteSpeed: 30,
                                                            delay: 70,
                                                            loop: true,
                                                            cursor: ""
                                                        }
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return gsap/* default.to */.ZP.to(window, {
                                        duration: 0,
                                        scrollTo: {
                                            y: "#HeroSlider",
                                            offsetY: 0
                                        }
                                    });
                                },
                                className: classnames_default()("absolute cursor-pointer bottom-0 right-0 text-red bg-primary h-[13.65rem] flex items-center justify-center w-[70px]", "_topMoreButton opacity-0 translate-x-[70px]"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "-rotate-90 -translate-y-10 relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: classnames_default()("inline-block w-[70px] h-[0.15rem] bg-white -translate-x-full absolute top-1/2 -left-[70%]", "_topMoreButtonLine")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white text-[14px] inline-block rotate-180 relative top-[1px]",
                                            children: "More"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var MobileHeroSection_MobileHeroSection = (MobileHeroSection);

;// CONCATENATED MODULE: ./src/views/Home/MobileHeroSection/index.tsx




/***/ })

}]);